// RouteChangeTracker.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initGA, trackPageview } from "./GoogleAnalytics";

const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    initGA();
  }, []);

  useEffect(() => {
    trackPageview(location.pathname);
  }, [location]);

  return null; // This component only tracks route changes
};

export default RouteChangeTracker;
